module.exports = __webpack_public_path__ + "img/loading.152dc5e3.png";